import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-50d64b40")
const _hoisted_1 = { class: "farmer-space-container" }
const _hoisted_2 = {
  key: 0,
  class: "top-message"
}
const _hoisted_3 = { class: "msg" }
const _hoisted_4 = { class: "item-wrap" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  key: 0,
  class: "imgs"
}
const _hoisted_9 = {
  key: 1,
  class: "videos"
}
const _hoisted_10 = { class: "time" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "operation" }
const _hoisted_14 = { class: "date" }
const _hoisted_15 = { class: "right-menu" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "cup" }, null, -1)
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "评论", -1)
const _hoisted_21 = {
  key: 2,
  class: "bottom-container"
}
const _hoisted_22 = {
  key: 0,
  class: "nice"
}
const _hoisted_23 = { class: "nice-item" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 1,
  class: "cup"
}
const _hoisted_26 = ["onClick", "onTouchstart", "onTouchend"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "content" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "reply" }, "回复", -1)
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "content" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "item-cup" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "field-wrap"
}
const _hoisted_35 = ["placeholder"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_preview_video = _resolveComponent("preview-video")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.loading,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.loading = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        (_ctx.notReadObj && _ctx.notReadObj.count > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "content",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickCount && _ctx.onClickCount(...args)))
              }, [
                _createVNode(_component_van_image, {
                  class: "left",
                  fit: "cover",
                  src: 
              _ctx.notReadObj.lastHeadImg
                ? _ctx.notReadObj.lastHeadImg+'?imageView2/1/w/200/h/200/rotate/0'
                : 'https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png'
            
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.notReadObj.count) + "条新消息", 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_list, {
          class: "list-wrap",
          "finished-text": "我已经到底了~~~",
          finished: _ctx.dataTotal === _ctx.dataList.length,
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "farmer-item",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_van_image, {
                    radius: "3px",
                    fit: "cover",
                    class: "left",
                    onClick: _withModifiers(($event: any) => (_ctx.toFarmerDetail(item.farmerId, 1)), ["stop"]),
                    src: 
                item.farmerHeadImg.length > 0
                  ? item.farmerHeadImg[0].url +
                    '?imageView2/1/w/200/h/200/rotate/0'
                  : 'https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/%E7%BB%84%20989%402x.png'
              
                  }, null, 8, ["onClick", "src"]),
                  _createElementVNode("div", {
                    class: "right",
                    onClick: _withModifiers(($event: any) => (_ctx.onInfo(item)), ["stop"])
                  }, [
                    _createElementVNode("div", {
                      class: "name",
                      onClick: _withModifiers(($event: any) => (_ctx.toFarmerDetail(item.farmerId, 1)), ["stop"])
                    }, _toDisplayString(item.farmerName), 9, _hoisted_6),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.content), 1),
                    (item.imgList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgList, (imgs, index) => {
                            return (_openBlock(), _createBlock(_component_van_image, {
                              class: "img",
                              radius: "0.25rem",
                              key: imgs.id,
                              fit: "cover",
                              src: imgs.url + '?imageView2/1/w/200/h/200/rotate/0',
                              onClick: _withModifiers(($event: any) => (_ctx.onPreviewImg(item.imgList, index)), ["stop"])
                            }, null, 8, ["src", "onClick"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (item.videoList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.videoList, (videos) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "poster-wrap",
                              key: videos.id
                            }, [
                              _createVNode(_component_van_image, {
                                class: "poster",
                                src: videos.coverImg,
                                radius: "0.25rem",
                                fit: "cover"
                              }, null, 8, ["src"]),
                              _createVNode(_component_van_image, {
                                class: "play",
                                src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/bofang.png",
                                onClick: _withModifiers(($event: any) => (_ctx.onPreviewVideo(videos.url)), ["stop"])
                              }, null, 8, ["onClick"]),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(videos.timeStr), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "location",
                      onClick: _withModifiers(($event: any) => (_ctx.toResource(item.sourceId)), ["stop"])
                    }, _toDisplayString(item.address), 9, _hoisted_11),
                    _createElementVNode("div", {
                      class: "source",
                      onClick: _withModifiers(($event: any) => (_ctx.toResource(item.sourceId)), ["stop"])
                    }, _toDisplayString(item.sourceName), 9, _hoisted_12),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.transfromDate(item.createTime)), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_van_image, {
                          class: "menu",
                          src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/more.png",
                          onClick: _withModifiers(($event: any) => (_ctx.onShow(item)), ["stop"])
                        }, null, 8, ["onClick"]),
                        _createElementVNode("div", {
                          class: "drawer",
                          style: _normalizeStyle(item.isShow ? 'width:10rem' : 'width:0rem')
                        }, [
                          _createElementVNode("div", {
                            class: "inner-content",
                            onClick: _withModifiers(($event: any) => (_ctx.onZan(item)), ["stop"])
                          }, [
                            _createVNode(_component_van_image, {
                              class: "zan",
                              src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/baiaixin.png"
                            }),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(item.zan ? "已赞" : "赞"), 1)
                          ], 8, _hoisted_16),
                          _hoisted_18,
                          _createElementVNode("div", {
                            class: "inner-content",
                            onClick: _withModifiers(($event: any) => (_ctx.onComment(item)), ["stop"])
                          }, [
                            _createVNode(_component_van_image, {
                              class: "zan",
                              src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/pinglun.png"
                            }),
                            _hoisted_20
                          ], 8, _hoisted_19)
                        ], 4)
                      ])
                    ]),
                    (item.zanList.length > 0 || item.comments.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (item.zanList.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_van_image, {
                                    class: "icon",
                                    src: "https://qnui.xfarmer.com/xfarmer-ui/h5FarmerSpace/lvaixin.png"
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.zanList, (value, idx) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: idx,
                                      onClick: _withModifiers(($event: any) => (_ctx.toFarmerDetailtwo(value, value.userType)), ["stop"])
                                    }, _toDisplayString(idx == 0 ? "" : ",") + _toDisplayString(value.name), 9, _hoisted_24))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (item.zanList.length > 0 && item.comments.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.comments, (comment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: comment.id,
                              class: _normalizeClass(
                      comment.id == _ctx.activeDelId.comId &&
                      item.id == _ctx.activeDelId.parId
                        ? 'active chat'
                        : 'chat'
                    ),
                              onClick: _withModifiers(($event: any) => (_ctx.onClickReply(comment, item)), ["stop"]),
                              onTouchstart: _withModifiers(($event: any) => (
                      _ctx.touchStart(comment.id, item.id, comment.canDel)
                    ), ["stop"]),
                              onTouchend: _withModifiers(($event: any) => (_ctx.touchEnd(comment.id, item.id)), ["stop"])
                            }, [
                              (!comment.replyName)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", {
                                      class: "person",
                                      onClick: _withModifiers(($event: any) => (
                          _ctx.toFarmerDetail(
                            comment.createType == 1
                              ? comment.farmerId
                              : comment.createUser,
                            comment.createType
                          )
                        ), ["stop"])
                                    }, _toDisplayString(comment.name) + "：", 9, _hoisted_27),
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(comment.content), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("span", {
                                      class: "person",
                                      onClick: _withModifiers(($event: any) => (
                          _ctx.toFarmerDetail(
                            comment.createType == 1
                              ? comment.farmerId
                              : comment.createUser,
                            comment.createType
                          )
                        ), ["stop"])
                                    }, _toDisplayString(comment.name), 9, _hoisted_29),
                                    _hoisted_30,
                                    _createElementVNode("span", {
                                      class: "person",
                                      onClick: _withModifiers(($event: any) => (
                          _ctx.toFarmerDetail(
                            (comment.replyUserType = 1
                              ? comment.replyFarmerId
                              : comment.replyUserId),
                            comment.replyUserType
                          )
                        ), ["stop"])
                                    }, _toDisplayString(comment.replyName) + "：", 9, _hoisted_31),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(comment.content), 1)
                                  ], 64)),
                              _withDirectives(_createElementVNode("div", {
                                class: "del-com",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.delCom && _ctx.delCom(...args)), ["stop"]))
                              }, " 删除 ", 512), [
                                [_vShow, 
                        item.id == _ctx.delSpeakobj.parId &&
                        comment.id == _ctx.delSpeakobj.comId
                      ]
                              ])
                            ], 42, _hoisted_26))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_5)
                ]),
                _hoisted_33
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"]),
    _createVNode(_component_preview_video, {
      visible: _ctx.previewVideo,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.previewVideo = $event)),
      url: _ctx.videoUrl
    }, null, 8, ["visible", "url"]),
    (_ctx.showReply)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createVNode(_component_van_field, null, {
            input: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                class: "reply-content",
                onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onReplyBlur && _ctx.onReplyBlur(...args))),
                onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
                ref: "replyField",
                type: "search",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.replyMessage = $event)),
                placeholder: _ctx.replyPlaceholder,
                maxlength: "255"
              }, null, 40, _hoisted_35), [
                [_vModelText, _ctx.replyMessage]
              ])
            ]),
            button: _withCtx(() => [
              _createElementVNode("button", {
                class: "field",
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onConfirmReply && _ctx.onConfirmReply(...args)), ["stop"]))
              }, "确定")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}